import Layout from "@/layout";

const storeRouter = {
  path: "/writing",
  component: Layout,
  redirect: "/writing/index",
  name: "Writing",
  meta: {
    title: "文章管理",
    icon: "clipboard"
  },
  children: [
    {
      path: "index",
      component: () => import("@/views/writing/type/index"),
      name: "WritingType",
      meta: { title: "文章分类", icon: "" }
    },
    {
      path: "list",
      component: () => import("@/views/writing/list/index"),
      name: "WritingIndex",
      meta: { title: "文章列表", icon: "" }
    },
    {
      path: "edit/:id?",
      component: () => import("@/views/writing/list/create/index"),
      name: "WritingEdit",
      meta: {
        title: "文章添加",
        noCache: true,
        activeMenu: `/writing/list`,
        parentPath: "/writing/list"
      },
      hidden: true
    }
  ]
};

export default storeRouter;
